module.exports = __webpack_public_path__ + "static/img/hnbc_01.0a9fac7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/jingdianfish/hnbc_01.png
// module id = AzWz
// module chunks = 0